var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4243 1.42426L25.8485 1L25 0.151472L24.5757 0.575736L25.4243 1.42426ZM0.575736 24.5757L0.151472 25L1 25.8485L1.42426 25.4243L0.575736 24.5757ZM1.42426 0.575736L1 0.151472L0.151472 1L0.575736 1.42426L1.42426 0.575736ZM24.5757 25.4243L25 25.8485L25.8485 25L25.4243 24.5757L24.5757 25.4243ZM24.5757 0.575736L0.575736 24.5757L1.42426 25.4243L25.4243 1.42426L24.5757 0.575736ZM0.575736 1.42426L24.5757 25.4243L25.4243 24.5757L1.42426 0.575736L0.575736 1.42426Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXBlack);
export default __webpack_public_path__ + "static/media/X-black.f587685e05c2aa04eb0da99b14afc40a.svg";
export { ForwardRef as ReactComponent };